import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";
import { ApolloLink, Observable } from "apollo-link";
import { onError } from "apollo-link-error";
import { Auth } from "aws-amplify";
import { withClientState } from "apollo-link-state";
import { notification } from "antd";

const cache = new InMemoryCache({ addTypename: false });

const request = async (opt) => {
  var token;

  try {
    token = (await Auth.currentSession())?.getIdToken()?.getJwtToken();
  } catch (err) {
    console.log("token err", err);
    return;
  }

  if (!token) return;

  if (process.env.NODE_ENV === "production") {
    opt.setContext({
      headers: {
        Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
      },
    });
  } else {
    opt.setContext({
      headers: {
        // UserId: "Division112",
        // UserId: "Region1",
        // UserId: "Managing1",
        Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
      },
    });
  }
};

const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable((observer) => {
      let handle;
      Promise.resolve(operation)
        .then((oper) => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          });
        })
        .catch(observer.error.bind(observer));

      return () => {
        if (handle) handle.unsubscribe();
      };
    })
);

export const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.map(({ message, locations, path }) =>
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        );

        let msg = graphQLErrors[0].message;
        if (typeof msg !== "string") {
          return;
        }

        const prefix = 'Unexpected error value: "';
        const suffix = '"';
        if (msg.startsWith(prefix) && msg.endsWith(suffix)) {
          msg = msg.slice(prefix.length, -suffix.length);
        }

        notification.error({ message: msg });
        // return graphQLErrors[0].message;
      }
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    requestLink,
    withClientState({
      defaults: {
        isConnected: true,
      },
      resolvers: {
        Mutation: {
          updateNetworkStatus: (_, { isConnected }, { cache }) => {
            cache.writeData({ data: { isConnected } });
            return null;
          },
        },
      },
      cache,
    }),
    new createUploadLink({ uri: `${process.env.REACT_APP_ADMIN_API}/graphql` }),
  ]),

  // uri: `${process.env.REACT_APP_ADMIN_API}/graphql`,

  cache,
});
